import { ReactElement } from 'react'
import {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType
} from 'next'

import Meta from '@/components/base/meta'
import Book from '@/components/layout/book'
import PageBuilder from '@/components/layout/builder'
import Layout from '@/components/layout/layout'
import SimplePage from '@/components/layout/simple-page'
import ThankYouPage from '@/components/layout/thank-you'
import { getPromiseFromFetch } from '@/utils/request'
import { API } from '@/constants'

import { WPPageData, WPRoutes } from '@/types'

export default function Page(
  pageProps: InferGetStaticPropsType<typeof getStaticProps>
) {
  if (pageProps.template === 'template/contacts.php')
    // @ts-ignore
    return <Book pageProps={pageProps} />
  if (pageProps.template === 'template/simple-text.php')
    // @ts-ignore
    return <SimplePage pageProps={pageProps} />
  if (pageProps.template === 'template/thank-you.php')
    // @ts-ignore
    return <ThankYouPage pageProps={pageProps} />

  return <PageBuilder pageProps={pageProps} />
}

Page.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout pageProps={pageProps}>
      <Meta pageProps={pageProps} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({
  params,
  locale,
  defaultLocale
}: GetStaticPropsContext<{ routes: string[] }>) {
  const res = await getPromiseFromFetch<WPPageData>({
    method: 'get',
    url: `/${locale === defaultLocale ? '' : `${locale}/`}${params?.routes.join('/')}/`
  })

  const { data: pageProps } = res

  if (pageProps.type === 'post' || pageProps.type === 'ads-landing')
    return { notFound: true }

  if (!pageProps || typeof pageProps !== 'object') return { notFound: true }

  return {
    props: {
      ...pageProps
    }
  }
}

export async function getStaticPaths({}: GetStaticPathsContext) {
  const { data: routes } = await getPromiseFromFetch<WPRoutes>({
    method: 'get',
    url: API.ROUTES
  })

  return {
    paths: routes.map((route) => ({
      params: { routes: route.routes.filter((item) => item !== route.locale) },
      locale: route.locale
    })),
    fallback: 'blocking' // false
  }
}
